import { theme } from '@chakra-ui/core';

/**
 * Tema base
 */
export const insightBtlTheme = {
  ...theme,
};
